'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

/* Actions */

var _actionsModuleInspector = require('actions/module-inspector');

var _actionsModuleInspector2 = _interopRequireDefault(_actionsModuleInspector);

var _actionsModule = require('actions/module');

var _actionsModule2 = _interopRequireDefault(_actionsModule);

/* Api */

var _apiModule = require('api/module');

var _apiModule2 = _interopRequireDefault(_apiModule);

/* Stores */

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _moduleType = require('./module-type');

var _moduleType2 = _interopRequireDefault(_moduleType);

exports['default'] = _reflux2['default'].createStore({

  listenables: [_actionsModuleInspector2['default']],

  init: function init() {
    this.listenTo(_actionsModule2['default'].selectModule, this.onModuleSelect);
    this.listenTo(_module3['default'], this.onModuleStoreUpdated);

    this.translations = {};
    this.selectedModule = null;
    this.selectedPropertyGroupName = null;
    this.saving = false;
    this.busy = false;
  },

  getInitialState: function getInitialState() {
    return this.selectedModule;
  },

  translate: function translate(key, properties, nullOnNotFound) {
    var translation = this.translations[key];

    if (translation === undefined) {
      if (nullOnNotFound) {
        return null;
      } else {
        return '[' + key + ']';
      }
    }

    return translation;
  },

  hasTranslation: function hasTranslation(key) {
    return this.translations[key] !== undefined;
  },

  getDefaultTranslation: function getDefaultTranslation(groupName, key) {
    if (!groupName || !key) {
      return;
    }

    var group = this.selectedModule.moduleType.propertyGroups.filter(function (propertyGroup) {
      return propertyGroup.name === 'content';
    })[0];
    var property = group.properties.filter(function (property) {
      return property.name === 'translations';
    })[0];
    var translation = property.values.filter(function (translation) {
      return translation.name === groupName;
    })[0];
    var defaultValue = translation.value ? translation.value[key] : '';

    return defaultValue;
  },

  onModuleSelect: function onModuleSelect() {
    this.moduleJustGotSelected = true;
  },

  onModuleStoreUpdated: function onModuleStoreUpdated(modules) {
    var _this = this;

    var selectedModules = modules.filter(function (module) {
      return module.selected;
    });

    if (!this.moduleJustGotSelected && selectedModules.length) {
      return;
    }

    this.moduleJustGotSelected = false;

    if (selectedModules.length === 1) {
      var _ret = (function () {
        var selectedModule = selectedModules[0];
        var selectedModuleId = selectedModule.id;

        if (_this.selectedModule && _this.selectedModule.id === selectedModuleId) {
          return {
            v: undefined
          };
        }

        /*this.translations = null
        this.selectedModule = null
        this.trigger(this.selectedModule)*/

        _this.translations = null;
        _this.selectedModule = null;

        _apiModule2['default'].details(selectedModuleId).done(function (module) {

          var moduleTypes = _moduleType2['default'].moduleTypes;

          module.moduleType = moduleTypes.find(function (moduleType) {
            return moduleType.id === selectedModule.moduleType.id;
          });

          _this.translations = module.moduleType.translations['en-US'];

          _this.selectedModule = module;

          _this.trigger(_this.selectedModule);
        });
      })();

      if (typeof _ret === 'object') return _ret.v;
    } else if (this.selectedModule) {
      this.translations = null;
      this.selectedModule = null;
      this.trigger(this.selectedModule);
    }
  },

  onModulePropertyGroupSelected: function onModulePropertyGroupSelected(name) {
    if (this.selectedPropertyGroupName === name) {
      name = null;
    }

    this.selectedPropertyGroupName = name;

    this.trigger(this.selectedModule);
  },

  onPerformModuleAction: function onPerformModuleAction(moduleId, groupName, actionName) {
    var _this2 = this;

    this.busy = true;
    this.trigger(this.selectedModule);

    var projectWindow = actionName === 'showTestSite' && window.open('#', '_blank');

    _apiModule2['default'].performAction(moduleId, { groupName: groupName, actionName: actionName }).done(function (response) {

      if (_this2.selectedModule) {
        _this2.selectedModule.state = response.state;
      }

      var data = response.data;

      if (data && data.perform) {
        switch (data.perform) {
          case 'open-link':
            if (projectWindow) {
              projectWindow.location = data.payload;
            }
            break;
        }
      }
    }).always(function () {
      _this2.busy = false;
      _this2.trigger(_this2.selectedModule);
    });
  },

  saveModuleChanges: function saveModuleChanges(changes) {
    var _this3 = this;

    var id = this.selectedModule.id;

    this.saving = true;
    this.busy = true;
    this.trigger(this.selectedModule);

    _apiModule2['default'].save(id, changes).done(function (data) {

      if (_this3.selectedModule) {
        _this3.selectedModule.state = data;
      }
    }).always(function () {
      _this3.saving = false;
      _this3.busy = false;

      _this3.trigger(_this3.selectedModule);
    });
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/module-inspector.js
 **/